import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from 'infrastructure/js/components/tooltip/tooltip';
import {getCoCAttachmentAcceptGenericTypes, getCoCAttachmentAcceptTypes} from '../../utils/cocHelper';

import './cocAttachmentButton.scss';

const attachmentTypeIcons = {
  PDF: { icon: 'pl-file-pdf' },
  GRAPH: { icon: 'pl-file-graph' },
  CSV: { icon: 'pl-file-csv' },
  EXCEL: { icon: 'pl-file-excel' },
  GENERIC: { icon: 'pl-file' },
};

const getStatus = (attachmentsCount, attachmentsTotal) => {
  if (!attachmentsCount) {
    return '';
  }
  return (attachmentsCount < attachmentsTotal) ? 'fail' : 'pass';
}


export default function CoCAttachmentButton({
                                              id,
                                              type,
                                              tooltip = null,
                                              buttonLabel = '',
                                              disabled = false,
                                              attachmentsTotal = 0 ,
                                              attachmentsCount = 0,
                                              onAttachmentChanged = null,
                                              emptyError = false,
                                            }) {

  const isGeneric = type === 'GENERIC';
  const isDisabled = (attachmentsTotal && attachmentsCount === attachmentsTotal) || disabled;

  const onClickHandler = (e) => {
    e.target.value = '';
  }

  const onSelectedFileChanged = (e) => {
    if (e.target.files?.length > 0) {
      onAttachmentChanged?.(e.target.files[0], type);
    }
  };

  const inputId = id || `fileChooser-${type}`;

  return (
    <div className="coc-attachment-button">
      <input type="file" id={inputId}
             disabled={isDisabled}
             className="input-file"
             accept={isGeneric ? getCoCAttachmentAcceptGenericTypes() : getCoCAttachmentAcceptTypes(type)}
             onClick={onClickHandler}
             onChange={onSelectedFileChanged}
      />

      <label className={cn('attach-button', getStatus(attachmentsCount, attachmentsTotal), {disabled: isDisabled}, {'generic': isGeneric}, {'empty-error': emptyError})}
             htmlFor={inputId}>
        <Tooltip placement="top" value={tooltip ?? type}>
          <span className={`attach-button-icon pl ${attachmentTypeIcons[type]?.icon ?? ''}`} />
        </Tooltip>
        <span className="attach-button-label">{isGeneric ? buttonLabel : `${attachmentsCount}/${attachmentsTotal}`}</span>
      </label>
    </div>
  )
}

CoCAttachmentButton.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  buttonLabel: PropTypes.string,
  disabled: PropTypes.bool,
  attachmentsTotal: PropTypes.number ,
  attachmentsCount: PropTypes.number,
  onAttachmentChanged: PropTypes.func,
  emptyError: PropTypes.bool,
}
